module.exports = "data:image/webp;base64,UklGRhwBAABXRUJQVlA4IBABAADQBQCdASoZABkAPpE+l0iloyIhKA1QsBIJZQDDNywA30n5ehoXuO4/9tAyu8Z2V7uRMbu7xELwAP7wS9/KFyvr+pUPTBWF80crvl/oxWGkBng9qXopwYZOV3dsBUcc+O1+ThKkA9tscj5jeBhYGgMv8O7m69a3dLCG61QV0wnvW1eO5btHs26UpXxYk43cIBTOL0TVb/ScRyEalvEGsQbHGN3jdyLkATVBkk393jaYN44Mui4MEtcRcfhXPBKCdY3PzqFBBgUon46S2tztrH4oVLYFirCGaR4pwXFWYchJQA1fF9HbquCo0HFfuT25sAtyIr+rAVNRwBIzGHTpy9hoX9Vb/YtVxJHLijHtFYAAAA=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/animal.webp
// module id = vV95
// module chunks = 14